module.exports = __webpack_public_path__ + "img/campus-small-4.302dbebf.jpg";